import React from 'react';
import { useNavigate } from 'react-router-dom';
import Game from './Game';

interface GamePageProps {
  gameId: string;
}

const GamePage: React.FC<GamePageProps> = ({ gameId }) => {
  const navigate = useNavigate();
  
  console.log('GamePage rendering with gameId:', gameId); // Thêm log để debug

  return (
    <div className="relative">
      <Game 
        gameId={gameId} 
        onBack={() => navigate('/')}
        speedMultiplier={0.01}
      />
    </div>
  );
};

export default GamePage;